module.exports = __webpack_public_path__ + "static/media/c8.76045dce.jpg";